import {RiArrowRightSLine} from "@remixicon/react";
import { Link } from "~/components/ui/link";
import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";
import lastChanceBg from "~/assets/last-chance-bg.mp4";
import { imageUrl } from "~/lib/image-url";

// Plain public/ string path, not a JS import (see the comment on bgImageSet in
// app/components/home/UseCases.tsx). No AVIF/WebP variant here: the <video poster>
// attribute takes a single URL with no format-negotiation mechanism.
const lastChanceBgPoster = imageUrl("/images/last-chance-bg-poster.jpg");

// Mobile uses Figma's M (12px padding, so padding plus border set the height).
// Desktop uses the shared L size.
const buttonSizing = "max-lg:h-auto max-lg:py-3 max-lg:w-[232px]";

export default function LastChance() {
  const { t } = useTranslation("home");
  return (
    <section className="relative isolate h-[248px] overflow-hidden bg-black lg:h-[310px]">
      <div aria-hidden className="absolute inset-0 overflow-hidden">
        <video
          className="absolute inset-0 h-full w-full object-cover object-[100%_50%] lg:object-[50%_31%]"
          src={lastChanceBg}
          poster={lastChanceBgPoster}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="absolute inset-0 bg-[#2A3141] opacity-[0.102]" />
      </div>
      <div className="gap-figma-spacing-2xl px-figma-padding-padding-l-r-pl-r-16 py-figma-padding-padding-t-b-pt-b-40 lg:py-figma-padding-padding-t-b-pt-b-32 relative z-10 flex h-full flex-col items-center justify-center lg:px-20">
        <h2 className="font-display text-figma-titles-sm-size text-figma-text-headers-secondary lg:text-figma-titles-xl-size lg:leading-display text-center leading-[1.15] font-extrabold">
          {t("last_chance.tagline")}
        </h2>
        <div className="flex flex-col items-center gap-4 lg:flex-row lg:gap-6">
          <Button asChild variant="primary" size="lg" className={buttonSizing}>
            <Link to=".">{t("last_chance.cta_primary")}</Link>
          </Button>
          <Button asChild variant="secondary-alt" size="lg" className={cn("group", buttonSizing)} iconRight={<RiArrowRightSLine className="group-hover:stroke-bouncie-500 stroke-figma-icon-inverse size-5 shrink-0" />}>
            <Link to=".">{t("last_chance.cta_secondary")}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
